<template lang="pug">
  LfLabelButtonComponent(
    :text="buttonText"
    :variant="variant"
    :size="size"
    :action="openUrl"
    :clickOnce="false"
  )
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import { LabelButtonSize, LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'

@Component({
  name: 'buttonLinkTemplate',
  components: {
    LfLabelButtonComponent
  }
})
export default class ButtonLinkTemplateComponent extends Vue {
  data: any
  variant = LabelButtonVariant.OUTLINED
  size = LabelButtonSize.SM

  get getValue() {
    const { field } = this.data.column
    return this.data[field]
  }

  get buttonText(): string {
    return this.$t('action_buttons.review').toString()
  }

  openUrl() {
    if (this.getValue) {
      window.open(this.getValue, '_blank')
    }
  }
}
</script>
